import 'rxjs/add/observable/of';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import get from 'lodash/get';
import { Observable } from 'rxjs/Observable';
import { log } from '@atlassian/jira-common-util-logging';
import { getBacklogRealtimeDebounceIntervalMillisecs } from '../../feature-flags';
import { REFRESH_SOURCE_REALTIME } from '../../model/constants';
import { refreshDataRequest } from '../../state/actions/app';
import {
	REALTIME_DISPATCH_EVENT,
	type RealtimeDispatchEventAction,
} from '../../state/actions/realtime/dispatch';
import { getAtlassianAccountId } from '../../state/selectors/app';
import type { Action, ActionsObservable, MiddlewareAPI, State } from '../../state/types';

const isInactiveTab = () => document.hidden;

const isNotCurrentUser = (state: State, action: RealtimeDispatchEventAction) =>
	getAtlassianAccountId(state) !==
	get(action, ['payload', 'event', 'payload', 'atlassianId'], null);

export const realtimeEventProcessEpic = (
	action$: ActionsObservable,
	store: MiddlewareAPI,
): Observable<Action> =>
	action$
		.ofType(REALTIME_DISPATCH_EVENT)
		.filter((action) => isNotCurrentUser(store.getState(), action))
		.filter(() => !isInactiveTab())
		.debounceTime(getBacklogRealtimeDebounceIntervalMillisecs())
		.switchMap(() => Observable.of(refreshDataRequest(REFRESH_SOURCE_REALTIME)))
		.catch((error) => {
			log.safeErrorWithoutCustomerData(
				'backlog.realtime.event.process.failure',
				'Failed to process realtime event',
				error,
			);
			return Observable.empty();
		});
